export default __webpack_public_path__ + "static/marintcase2-9cdbfc9cf206e64e33c7387df1ca45b3.png";